import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import LandingPage from "./pages/LandingPage";

const CoursePage = lazy(() => import("./pages/CoursePage"));
const VirtualOffice = lazy(() => import("./pages/VirtualOffice"));

function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" /></div>}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/course/:courseId" element={<CoursePage />} />
        <Route path="/virtual-office" element={<VirtualOffice />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </Suspense>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
